import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    currentTimestamp: string = 'dit jaar';

    dataInEur: boolean = false;

    energyPrice: number = 0.23;

    demoData: boolean = false;

    refreshData() {
        window.dispatchEvent(new CustomEvent("refreshData"));
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/_shared/services/globals.ts